// extracted by mini-css-extract-plugin
module.exports = {"container":"Landing_container__3QoBT","btn":"Landing_btn__3YU-l","titulo":"Landing_titulo__3yD17"};